const angular = require('angular')
const get = require('lodash/get')
const { hook: globalHook, utils: globalUtils } = require('js/global/module')

module.exports = ['$scope', '$q', 'netFolderService', '$translate', 'wechatService', '$stateParams', '$ionicPopover', '$ionicActionSheet', '$state',
  '$utils', '$phoneModal', '$sce', '$ionicHistory', '$timeout', '$loading', '$window', 'User', '$rootScope', 'LocalStorage', '$http', 'mailService', 'readService', 'globalMailService',
  function ($scope, $q, netFolderService, $translate, wechatService, $stateParams, $ionicPopover, $ionicActionSheet, $state,
    $utils, $phoneModal, $sce, $ionicHistory, $timeout, $loading, $window, User, $rootScope, LocalStorage, $http, mailService, readService, globalMailService) {
    $scope.mid = $stateParams.mid
    $scope.folderType = $stateParams.type
    // 打来文件详情模板
    $scope.openFileDetailModal = function (message, type) {
      const _nextOp = ($rootScope.settings.wechatMiniProgram && type !== 'ent' && type !== 'per') || !$rootScope.settings.wechatMiniProgram
      console.log('_nextOp: ', _nextOp, type !== 'ent' && type !== 'per')
      if (_nextOp) {
        $scope.fileDetailModal = $phoneModal.fromTemplate(require('views/netFolder/fileDetail.html'), {
          scope: $scope,
          animation: 'scale-in'
        })
        $scope.fileDetailModal.show()
      }
      $scope.openFileDetail(message, type)
    }

    $scope.openFileDetail = function (message, type) {
      $scope.mid = message.id
      $scope.folderType = type
      initFileInfos($scope.mid, $scope.folderType, message)
    }

    function initFileInfos(mid, type, message) {
      $scope.file = ''
      if (type === 'ent') {
        netFolderService.getFileInfos(mid, type).then(function (data) {
          $scope.file = data['var'][0]
          $scope.file.isEnt = true
          $scope.getFileDetail()
          // 企业网盘需要权限的判断
          netFolderService.getFolderList($scope.file.fid, { isEntFolder: true }).then(function (data) {
            const adminType = data['var'] ? data['var'].adminType : ''
            const accessRole = data['var'] ? data['var'].accessRole : ''
            const isUploader = netFolderService.isUploader($scope.file.uploader)
            $scope.isFolderAdmin = adminType.toLowerCase() === 'folderadmin'
            $scope.ownWritePermission = accessRole.toLowerCase().indexOf('w') !== -1 && isUploader
          })
        }, function (error) {
          console.log(error)
        }).finally(function () {
        })
      } else if (type === 'per') {
        netFolderService.getFileInfos(mid, type).then(function (data) {
          $scope.file = data['var'][0]
          $scope.getFileDetail()
        }, function (error) {
          console.log(error)
        }).finally(function () {
        })
      } else if (type === 'ftc') {
        getFtcFileInfo(mid, type)
      } else if (type === 'rel') {
        $scope.file = message
        $scope.getFileDetail()
      }
    }
    // 获取文件中转站文件详情
    function getFtcFileInfo(mid, type) {
      $scope.isLoading = true
      netFolderService.getFileInfos(mid, type).then(function (data) {
        data.var[0].formatRemaintime = getFormatRemaintime(data.var[0].misc.remaintime)
        data.var[0].formatDownloadTimes = $translate.instant('NETFOLDER.DOWNLOADTOTAL', { count: data.var[0].misc.dlTotal || 0 })
        $scope.file = data.var[0]
        $scope.getFileDetail()
      }, function (error) {
        console.log(error)
      }).finally(function () {
        $scope.isLoading = false
      })
    }
    // 附件详情
    $scope.getFileDetail = function () {
      if ($scope.folderType === 'rel') {
        formatAttachment()
      } else {
        formatFile()
      }
      $scope.file.path = $scope.file.id
      $scope.file.downloadURL = netFolderService.downloadFile($scope.file.id, $scope.file.isEnt) +
        '&filename=' + encodeURIComponent($scope.file.name)
      // 个人网盘和企业网盘才提供小程序预览和分享
      if ($rootScope.settings.wechatMiniProgram && ($scope.folderType === 'ent' || $scope.folderType === 'per')) {
        console.log('file', $scope.file)
        const accountStorage = LocalStorage.getItem('account')
        const userConfig = accountStorage[accountStorage.currentUserId]
        if ($scope.file.isEnt) {
          $scope.file.enfUid = userConfig.netfolder.uid
          $scope.file.netDiskUid = userConfig.netfolder.uid
        } else {
          $scope.file.netDiskUid = userConfig
        }
        uni.navigateTo({
          url: '/pages/file/file?attachDetail=' + encodeURIComponent(JSON.stringify($scope.file))
        })
      }
    }
    // 格式化网盘文件
    function formatFile() {
      $scope.file.isPreview = $utils.$attachment.isSupportPreview($scope.file.name)
      const arr = ($scope.file.name || '').split('.')
      const type = ($scope.file.name.indexOf('.') != -1) ? arr[arr.length - 1] : ''
      arr.pop()
      $scope.file.pName = arr.join('')
      $scope.file.fileType = type ? ('.' + type) : type
      $scope.file.formattype = $utils.$attachment.getIconClass($scope.file.name, $scope.file.contentType)
      $scope.file.formatSize = $utils.$size.format($scope.file.size)
      $scope.curAttachment = $scope.file
    }
    // 格式化来往附件
    function formatAttachment() {
      $scope.file.isPreview = $utils.$attachment.isSupportPreview($scope.file.attn)
      const arr = ($scope.file.attn || '').split('.')
      const type = ($scope.file.attn.indexOf('.') != -1) ? arr[arr.length - 1] : ''
      arr.pop()
      $scope.file.pName = arr.join('')
      $scope.file.fileType = type ? ('.' + type) : type
      $scope.file.formattype = $utils.$attachment.getIconClass($scope.file.attn)
      $scope.file.formatSize = $utils.$size.format($scope.file.size)
      $scope.curAttachment = $scope.file
    }
    $scope.closeFileDetail = function () {
      $scope.fileDetailModal.remove()
    }
    // 有效期
    function getFormatRemaintime(remainTime) {
      let days, hours
      if (remainTime % 86400000 > 0) {
        days = Math.floor(remainTime / 86400000)
      } else {
        days = 0
      }
      hours = Math.ceil(remainTime / 3600000 - (24 * days))
      if (hours === 24) {
        days += 1
        hours = 0
      }
      const time = $translate.instant('NETFOLDER.VALID_TIME', {days: days, hours: hours})
      return time
    }
    // 他处点击监听
    addMoreOptionslListener()
    function addMoreOptionslListener() {
      document.addEventListener('click', function (event) {
        if (!event.target.classList.contains('opItem') && !event.target.classList.contains('icon-icon_more')) {
          $scope.showMore = false
          $scope.$digest()
        }
      })
    }
    // 文件续期
    $scope.renewalFile = function (id) {
      netFolderService.renewalFile(id).then(function () {
        $utils.$notify.set({ message: $translate.instant('NETFOLDER.RENEWALFILE_SUCCESS') })
        netFolderService.getFileInfos($scope.mid, $scope.folderType).then(function (data) {
          data.var[0].formatRemaintime = getFormatRemaintime(data.var[0].misc.remaintime)
          $scope.file.formatRemaintime = data.var[0].formatRemaintime
        }, function (error) {
          console.log(error)
        })
      }, function (error) {
        console.log(error)
        $utils.$notify.set({ message: $translate.instant('NETFOLDER.RENEWALFILE_FAIL') })
      })
    }
    /* handle rename file name */
    $scope.renameFile = function () {
      $scope.popover.hide()
      $scope.fileData = {}
      $scope.fileData.name = $scope.file.pName
      $scope.renameFileModal = $phoneModal.fromTemplate(require('views/netFolder/renameFileModal.html'), {
        scope: $scope,
        animation: 'slide-in-up'
      })
      $scope.renameFileModal.show()
    }

    $scope.cancelRenameFile = function () {
      $scope.renameFileModal.remove()
      $scope.fileData.name = ''
    }

    $scope.confirmRenameFile = function (newFilename) {
      if (newFilename !== $scope.file.pName) {
        const type = $scope.file.fileType
        const name = $scope.fileData.name + type
        netFolderService.updateFileInfo($scope.mid, name, $scope.folderType).then(function (data) {
          $scope.file.name = name
          if ($scope.mid && angular.isArray($scope.fileList)) {
            angular.forEach($scope.fileList, function (file, index) {
              if (file.id == $scope.mid) {
                $scope.fileList[index].name = name
              }
            })
          }
          $utils.$notify.set({ message: $translate.instant('NETFOLDER.RENAME_SUC') })
          formatFile()
          $scope.fileData.name = ''
          $scope.renameFileModal.remove()
        }).catch(function (err) {
          if (err.code == 'FA_NAME_INVALID') {
            $utils.$notify.set({ message: $translate.instant('NETFOLDER.FA_NAME_INVALID') })
          }
        })
      } else if (newFilename == $scope.file.pName) {
        $utils.$notify.set({ message: $translate.instant('NETFOLDER.FILE_NAME_NO_CHANGE') })
      }
    }

    /* 更多选项 */
    $scope.showMore = false
    $scope.moreOperation = function ($event) {
      $scope.showMore = !$scope.showMore
    }

    $scope.closePopover = function () {
      $scope.popover.hide()
    }

    $scope.deleteFile = function () {
      $scope.closePopover()
      $ionicActionSheet.show({
        titleText: $translate.instant('NETFOLDER.DELETE_FILE_TIPS'),
        destructiveText: "<p class='actionText'>" + $translate.instant('OP.DELETE') + '</p>',
        cancelText: $translate.instant('OP.CANCEL'),
        destructiveButtonClicked: function () {
          netFolderService.deleteFiles([$scope.mid], $scope.folderType).then(function (data) {
            _refreshBackToView($scope.mid)
            $utils.$notify.set({ message: $translate.instant('NETFOLDER.NF_DELETE_SUC') })
          })
          return true
        },
        cancel: function () {
          // to do when cancel
        }
      })
    }

    function _refreshBackToView(fileID) {
      if (fileID && angular.isArray($scope.fileList)) {
        angular.forEach($scope.fileList, function (file, index) {
          if (file.id == fileID) {
            $scope.fileList.splice(index, 1)
          }
        })
      }
      $scope.closeFileDetail()
    }

    $scope.sendMailWithAttach = function () {
      if (!$scope.file) return

      const attachment = $scope.file
      attachment.from = attachment.uploader
      attachment.filename = attachment.name
      attachment.folderType = $scope.folderType

      mailService.checkAttachmentRisk([attachment], $translate.instant('NETFOLDER.SEND_WITH_ATTACH')).then(res => {
        if (!res) return

        netFolderService.setComposeFile($scope.file)
        switch ($scope.folderType) {
          case 'ent':
            $state.go('frame.compose', { action: 'composeWithNetfolderFile' })
            break
          case 'per':
            $state.go('frame.compose', { action: 'composeWithNetfolderFile' })
            break
          case 'ftc':
            $state.go('frame.compose', { action: 'composeWithTrsFile' })
            break
          case 'rel':
            $state.go('frame.compose', { action: 'composeWithInternalAttachment' })
            break
        }
        $scope.closeFileDetail()
      })
      $scope.closePopover()
    }

    // 企业网盘，个人网盘文件下载
    $scope.downloadFile = function (event) {
      const attachment = $scope.file
      attachment.from = attachment.uploader
      attachment.filename = attachment.name
      mailService.checkAttachmentRisk([attachment], $translate.instant('READ.DOWNLOAD_ATTACHMENT')).then(res => {
        if (!res) return

        attachment.attsize = attachment.size
        $scope.startDownload(attachment)
      })
      $scope.closePopover()
    }
    // 来往附件下载
    $scope.downloadRelAttachment = function () {
      if ($rootScope.settings.wechatMiniProgram) {
        $utils.$notify.set({ message: $translate.instant('MINI_PROGRAM.DOWNLOAD_NOT_SUPPORTED') })
        return
      }

      // 当开启屏蔽外网下载附件配置时执行以下操作
      if ($rootScope.settings.disableExtranetDownload) {
        const account = LocalStorage.getItem('account') || {}
        const currentUser = account[account.currentUserId] || {}
        const isIntranetIp = get(currentUser, '$ajc.intranetAddr', true)
        if (!isIntranetIp) {
          $utils.$notify.set({ message: $translate.instant('READ.OUTER_NET_DOWNLOAD_TIPS') })
          return
        }
      }

      const attachment = $scope.file
      // attachment.from = attachment.from
      attachment.filename = attachment.attn
      mailService.checkAttachmentRisk([attachment], $translate.instant('NETFOLDER.DOWNLOAD')).then(res => {
        if (!res) return

        // 获取附件contentType, estimateSize等信息
        const returnAttSize = $rootScope.settings.featureControl.read.enableAttachmentDecodedSize || undefined
        netFolderService.readMessagePart($scope.file.id, $scope.file.partId, returnAttSize).then(res => {
          if (!res || res.code !== 'S_OK') return $q.reject(res)

          attachment.contentType = res.var.contentType
          attachment.attsize = res.var.attsize
          attachment.estimateSize = res.var.estimateSize
          attachment.filename = res.var.filename
          attachment.downloadURL = mailService.getDownloadURL(attachment.id, attachment.partId) + '&filename=' + encodeURIComponent(attachment.filename)

          $scope.startDownload(attachment)
        })
      })
    }
    // 统一网盘文件下载
    $scope.startDownload = function (attachment) {
      const sentDate = attachment.sentDate || attachment.creationDate || ''
      const urlPrefix = User.getCurrentUser().wmsvrClient.getWmsvrURLPrefix()
      const byToken = $rootScope.settings.featureControl.read.enableAttachmentDownloadByToken || $utils.$misc.MD.isWeChat
      const getDownloadURLDefer = byToken ? $http({
        method: 'GET',
        url: urlPrefix + '/cmcu_addon/generateToken.jsp?sid=' + User.getCurrentUser().sid
      }).then(res => {
        const params = { token: res.data.result, mid: attachment.id }
        attachment.partId && (params.partId = attachment.partId)
        attachment.uploader && (params.type = 'nf')
        return globalUtils.setQueryParams(`${urlPrefix}/cmcu_addon/readAttachment.jsp`, params)
      }) : $q.resolve(
        globalUtils.setQueryParams(attachment.downloadURL, {
          estimateSize: attachment.attsize,
          ctype: attachment.contentType,
          time: (new Date(sentDate.replace(/-/g, '/'))).getTime(),
        })
      )
      getDownloadURLDefer.then(downloadURL => {
        const copyAttachment = angular.copy(attachment)
        copyAttachment.downloadURL = downloadURL
        globalHook.exec('handleAttachmentDownload', copyAttachment).catch(_ => {
          if ($rootScope.settings.wxwork.enable && $utils.$misc.MD.isWorkWeChat) { // 企业微信下载
            // TODO: 考虑后续是否把readAttachment.jsp都替换成这里的下载方式
            // 特殊处理企业微信加密附件的下载
            if (attachment.mailCipherPassword) {
              const token = globalUtils.getQueryParams(downloadURL, 'token')
              downloadURL = globalUtils.setQueryParams(attachment.downloadURL, {
                estimateSize: attachment.attsize,
                ctype: attachment.contentType,
                time: (new Date(sentDate.replace(/-/g, '/'))).getTime(),
                cToken: token.split(':')[1]
              })
            }
            wechatService.previewFile(downloadURL, attachment.attsize, attachment.filename)
          } else { // 其他
            console.log('--- downloadAttachment ---', downloadURL)
            $window.location.href = downloadURL
          }
        })
      })
    }
    // 保存至个人网盘
    $scope.saveToPersonalDisk = function() {
      const attachment = $scope.file
      // attachment.from = attachment.from
      attachment.filename = attachment.attn
      mailService.checkAttachmentRisk([attachment], $translate.instant('NETFOLDER.SAVE_TO_PERSONALDISK')).then(res => {
        if (!res) return

        openNTFModal()
      })
    }
    //  打开个人网盘视图
    function openNTFModal() {
      netFolderService.getFolderList(0, {}).then(function (data) {
        if (data['code'] == 'S_OK') {
          $scope.ntFolderList = data['var']
          ntFolderModal()
        }
      })
      $scope.attachpopover && $scope.attachpopover.hide()
    }

    function ntFolderModal() {
      $phoneModal.fromTemplateUrl('ntfList.html', {
        scope: $scope,
        animation: 'slide-in-up'
      }).then(function (modal) {
        modal.el.style.zIndex = 15
        $scope.ntFolderList.modal = modal
        modal.show()
      })
    }
    // 关闭个人网盘视图
    $scope.closeNTFModal = function (ntFolderList) {
      ntFolderList.modal.hide()
    }
    $scope.openChildrenNTFModal = function (ntFolderList, folder) {
      $scope.ntFolderList = folder
      $scope.ntFolderList.parent = ntFolderList
      $scope.closeNTFModal(ntFolderList)
      ntFolderModal()
    }

    $scope.backToParentModal = function (ntFolderList) {
      ntFolderList = ntFolderList || $scope.ntFolderList
      if (ntFolderList.parent) {
        $scope.ntFolderList = ntFolderList.parent
        ntFolderList.parent.modal.show()
      }
      $scope.closeNTFModal(ntFolderList)
    }
    $scope.saveMessageToNF = function () {
      const mid = $scope.file.id
      const part = $scope.file.partId
      const parts = mid + '/' + part
      $scope.ntFolderList.modal.remove()
      readService.saveMessageToNF({ fid: $scope.ntFolderList.id, parts: [parts] }).then(function (data) {
        if (data['code'] == 'S_OK') {
          $utils.$notify.set({message: $translate.instant('NETFOLDER.SAVE_TO_PNF_SUCCESS')})
        }
      }, function (error) {
        if (error['code'] == 'FA_OVERFLOW') {
          $utils.$pop.alertPopup($translate.instant('READ.SAVE_TO_PNF_FAILED'), $translate.instant('READ.FA_OVERFLOW'))
        }
      })
    }
    $scope.previewFile = function () {
      const $ajc = User.getConfig()['$ajc']
      const enfUid = $scope.folderType === 'ent' ? $ajc.nf.enfUid : ''
      let previewURL
      if ($scope.folderType === 'rel') {
        previewURL = $utils.$attachment.getPreviewUrl({ mid: $scope.file.id, part: $scope.file.partId })
      } else {
        previewURL = $utils.$attachment.getPreviewUrl({ fileId: $scope.mid, uid: enfUid })
      }
      globalMailService.openAttachPreviewModal($scope, previewURL)
    }
  }
]



// WEBPACK FOOTER //
// ./src/js/netFolder/fileDetailCtrl.js